import PropTypes from 'prop-types';
import merge from 'lodash/merge';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Card, CardHeader, Box } from '@mui/material';
// components
import { BaseOptionChart } from '../../../components/chart';

// ----------------------------------------------------------------------

AppWebsiteVisits.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default function AppWebsiteVisits({ title, xtittle, ytittle, subheader, chartLabels, chartData, ...other }) {
    // Identify indices where all series are 0
    const zeroIndices = chartLabels.map((_, i) =>
      chartData.every((series) => series.data[i] === 0)
    );
  
    // Replace zero points with `null` to hide those positions on the chart
    const processedData = chartData.map((series) => ({
      ...series,
      data: series.data.map((value, i) => (zeroIndices[i] ? null : value)),
    }));

  const chartOptions = merge(BaseOptionChart(), {
    plotOptions: { bar: { columnWidth: '16%', } },
    fill: { type: processedData.map((i) => i.fill) },
    labels: chartLabels,
    yaxis: {
      title: {
        text: ytittle
      },
    },
    xaxis: {
      title: {
        text: xtittle
      }
    },
    // xaxis: { type: 'datetime' },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return y !== null ? `${y.toFixed(0)} ` : '0';
          }
          return y;
        },
      },
    },
  });

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />
      <Box dir="ltr">
        <ReactApexChart type="line" series={processedData} options={chartOptions} height={200} />
      </Box>
    </Card>
  );
}
